export enum ResourceType {
  ALL = 'ALL',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export const ResourceTypeNames: Record<ResourceType, string> = {
  [ResourceType.ALL]: 'All',
  [ResourceType.PRIMARY]: 'Primary Resources',
  [ResourceType.SECONDARY]: 'Secondary Resources',
};
